<template>
    <v-container fluid>
        <v-card class="pa-4">
           

            <!-- Filtros -->
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="6" md="3">
                        <v-menu
                            v-model="menu_fecha_desde"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="filtros.fecha_desde"
                                    label="Fecha Alta Cliente Desde"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    clearable
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="filtros.fecha_desde"
                                @input="menu_fecha_desde = false"
                                :first-day-of-week="1"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>

                    <v-col cols="12" sm="6" md="3">
                        <v-menu
                            v-model="menu_fecha_hasta"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="filtros.fecha_hasta"
                                    label="Fecha Alta Cliente Hasta"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    clearable
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="filtros.fecha_hasta"
                                @input="menu_fecha_hasta = false"
                                :first-day-of-week="1"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>

                    <v-col cols="12" md="4" class="d-flex align-center">
                        <v-btn
                            color="primary"
                            @click="cargarDatos"
                            :loading="isloading"
                            class="mr-2"
                        >
                            <v-icon left>mdi-magnify</v-icon>
                            Buscar
                        </v-btn>
                        <v-btn
                            color="secondary"
                            @click="limpiarFiltros"
                            :disabled="isloading"
                            class="mr-2"
                        >
                            <v-icon left>mdi-refresh</v-icon>
                            Limpiar
                        </v-btn>
                        <v-btn
                            color="success"
                            @click="descargarExcel"
                            :disabled="isloading || proyectos.length === 0"
                        >
                            <v-icon left>mdi-download</v-icon>
                            Excel
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>

            <!-- Gráficas -->
            <v-card-text v-if="proyectos.length > 0">
                <v-row>
                    <v-col cols="12" md="6">
                        <v-card>
                            <v-card-title>
                                <v-icon left color="primary">mdi-chart-pie</v-icon>
                                Origen
                            </v-card-title>
                            <v-card-text>
                                <apexchart 
                                    type="pie" 
                                    :options="origenChartOptions" 
                                    :series="origenChartSeries"
                                    height="300"
                                ></apexchart>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card>
                            <v-card-title>
                                <v-icon left color="primary">mdi-chart-pie</v-icon>
                                Campaña
                            </v-card-title>
                            <v-card-text>
                                <apexchart 
                                    type="pie" 
                                    :options="campanaChartOptions" 
                                    :series="campanaChartSeries"
                                    height="300"
                                ></apexchart>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>

            <!-- Tabla de resultados -->
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="proyectos"
                    :loading="isloading"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-options': [10, 25, 50, -1],
                        'items-per-page-text': 'Proyectos por página'
                    }"
                    class="elevation-1"
                >
                    <template v-slot:item.fecha_alta="{ item }">
                        {{ formatDate(item.fecha_alta) }}
                    </template>

                    <template v-slot:item.origen="{ item }">
                        <v-chip
                            :color="getOrigenColor(item.origen)"
                            text-color="white"
                            small
                        >
                            {{ item.origen || 'No especificado' }}
                        </v-chip>
                    </template>

                    <template v-slot:item.campana="{ item }">
                        <v-chip
                            color="blue"
                            text-color="white"
                            small
                        >
                            {{ item.campana || 'No especificada' }}
                        </v-chip>
                    </template>

                    <template v-slot:no-data>
                        <v-alert type="info" class="ma-4">
                            No se encontraron proyectos de Yotico con los filtros de fecha de alta del cliente aplicados.
                        </v-alert>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
    name: 'InformeYotico',
    components: {
        apexchart: VueApexCharts,
    },
    data() {
        return {
            proyectos: [],
            filtros: {
                fecha_desde: null,
                fecha_hasta: null,
            },
            menu_fecha_desde: false,
            menu_fecha_hasta: false,
            headers: [
                {
                    text: 'Nombre',
                    value: 'nombre',
                    sortable: true,
                },
                {
                    text: 'Nombre Fiscal',
                    value: 'nombre_fiscal',
                    sortable: true,
                },
                {
                    text: 'Email',
                    value: 'email',
                    sortable: true,
                },
                {
                    text: 'Fecha Alta Cliente',
                    value: 'fecha_alta',
                    sortable: true,
                },
                {
                    text: 'Origen',
                    value: 'origen',
                    sortable: true,
                },
                {
                    text: 'Campaña',
                    value: 'campana',
                    sortable: true,
                },
            ],
        };
    },
    mounted() {
        this.cargarDatos();
    },
    methods: {
        async cargarDatos() {
            try {
                this.$store.dispatch('isLoading', true);
                
                const params = {};
                if (this.filtros.fecha_desde) {
                    params.fecha_desde = this.filtros.fecha_desde;
                }
                if (this.filtros.fecha_hasta) {
                    params.fecha_hasta = this.filtros.fecha_hasta;
                }

                const response = await axios.get('api/informes-yotico', { params });
                this.proyectos = response.data.data || [];
                
            } catch (error) {
                console.error('Error al cargar datos:', error);
                this.$toast.error('Error al cargar los datos del informe');
            } finally {
                this.$store.dispatch('isLoading', false);
            }
        },

        limpiarFiltros() {
            this.filtros = {
                fecha_desde: null,
                fecha_hasta: null,
            };
            this.cargarDatos();
        },

        async descargarExcel() {
            try {
                this.$store.dispatch('isLoading', true);
                
                const params = {};
                if (this.filtros.fecha_desde) {
                    params.fecha_desde = this.filtros.fecha_desde;
                }
                if (this.filtros.fecha_hasta) {
                    params.fecha_hasta = this.filtros.fecha_hasta;
                }

                const response = await axios.get('api/informes-yotico-excel', { 
                    params,
                    responseType: 'blob'
                });

                // Crear el enlace de descarga
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `informe_yotico_${new Date().toISOString().split('T')[0]}.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);

                this.$toast.sucs('Archivo Excel descargado correctamente');
                
            } catch (error) {
                console.error('Error al descargar Excel:', error);
                this.$toast.error('Error al descargar el archivo Excel');
            } finally {
                this.$store.dispatch('isLoading', false);
            }
        },

        formatDate(date) {
            if (!date) return 'No especificada';
            const fecha = new Date(date);
            return fecha.toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        },

        getOrigenColor(origen) {
            if (!origen) return 'grey';
            
            const colores = {
                'Facebook Lead': 'blue',
                'Google Lead': 'red',
                'Web': 'green',
                'Referido': 'orange',
            };
            
            return colores[origen] || 'grey';
        },

        generarDatosGrafica(datos, campo) {
            const conteo = {};
            datos.forEach(item => {
                const valor = item[campo] || 'No especificado';
                conteo[valor] = (conteo[valor] || 0) + 1;
            });

            const labels = Object.keys(conteo);
            const series = Object.values(conteo);
            
            return { labels, series };
        },
    },
    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },

        origenChartOptions() {
            const datos = this.generarDatosGrafica(this.proyectos, 'origen');
            return {
                chart: {
                    type: 'pie',
                },
                labels: datos.labels,
                colors: ['#2196F3', '#F44336', '#4CAF50', '#FF9800', '#9C27B0', '#607D8B'],
                legend: {
                    position: 'bottom',
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            };
        },

        origenChartSeries() {
            const datos = this.generarDatosGrafica(this.proyectos, 'origen');
            return datos.series;
        },

        campanaChartOptions() {
            const datos = this.generarDatosGrafica(this.proyectos, 'campana');
            return {
                chart: {
                    type: 'pie',
                },
                labels: datos.labels,
                colors: ['#2196F3', '#F44336', '#4CAF50', '#FF9800', '#9C27B0', '#607D8B', '#795548', '#E91E63'],
                legend: {
                    position: 'bottom',
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            };
        },

        campanaChartSeries() {
            const datos = this.generarDatosGrafica(this.proyectos, 'campana');
            return datos.series;
        },
    },
};
</script> 